<template>
  <component
    :is="ModalComponent"
    :inbox-name="inboxName"
    :inbox-id="inboxId"
    :show="show"
    :integration_type="integrationType"
    @close="$emit('close')"
    @navigate="$emit('navigate', $event)"
    @save="$emit('save', $event)"
    @success="$emit('success', $event)"
  />
</template>

<script>
import { computed, defineAsyncComponent } from 'vue';
import { useComponentVersion } from 'dashboard/composables/useComponentVersion';

export default {
  name: 'InboxModal',
  props: {
    inboxName: {
      type: String,
      default: '',
    },
    inboxId: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
    integrationType: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'navigate', 'save', 'success'],
  setup() {
    const { version } = useComponentVersion('inbox_modal');

    const ModalComponent = computed(() => {
      if (version.value === 'oauth') {
        return defineAsyncComponent(() =>
          import('./InboxModal/InboxModalOAuth.vue')
        );
      }
      return defineAsyncComponent(() =>
        import('./InboxModal/InboxModalDefault.vue')
      );
    });

    return {
      ModalComponent,
    };
  },
};
</script>
